"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  SUCCESS: "@@analytic-data-export/success",
  ERROR: "@@analytic-data-export/error",
  RESET: "@@analytic-data-export/reset",
  RECORDS_EXPORT_DOWNLOAD: "@@analytic-data-export/records-export-download",
  RECORDS_EXPORT_DOWNLOAD_SITE: "@@analytic-data-export/records-export-download-site",
  RECORDS_EXPORT_DOWNLOAD_REPORT: "@@analytic-data-export/records-export-download-report",
  SYSTEM_WIDE_DATA_EXPORT_DOWNLOAD: "@@analytic-data-export/system-wide-data-export-download"
};
exports.actionTypes = actionTypes;